import { GET_SCANNING_MODULE_SUCCESS, GET_SCANNING_MODULE_FAILURE } from '../constants/MTag';
import { onSuccess, onFailure } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case GET_SCANNING_MODULE_SUCCESS:
			return onSuccess(state, action);
		case GET_SCANNING_MODULE_FAILURE:
			return onFailure(state, action);
		default:
			return { ...state };
	}
};
